import { Locale } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const languageDictionary = createSimpleDictionary([
    { id: Locale.English, name: 'dictionaries.english' },
    { id: Locale.Portuguese, name: 'dictionaries.portuguese' },
]);
